import { cx } from "@/utils";
import {
  Arrow,
  Content,
  DropdownMenuContentProps,
  Portal,
} from "@radix-ui/react-dropdown-menu";

import styles from "./Dropdown.module.css";

/**
 * DropdownMenu
 * Container for the DropdownItems
 */

const DropdownMenu: React.FunctionComponent<
  DropdownMenuContentProps & { withPortal?: boolean }
> = ({ withPortal = true, children, className, ...props }) => {
  function renderContent() {
    return (
      <Content
        className={cx("dropdown-menu", styles.menu, className)}
        {...props}
      >
        {children}
        <Arrow className={styles.arrow} />
      </Content>
    );
  }

  if (withPortal) {
    return <Portal>{renderContent()}</Portal>;
  }

  return renderContent();
};

export default DropdownMenu;
